import { render } from "./AttrSchemeGraphV2.vue?vue&type=template&id=f64380e6"
import script from "./AttrSchemeGraphV2.vue?vue&type=script&lang=js"
export * from "./AttrSchemeGraphV2.vue?vue&type=script&lang=js"

import "./AttrSchemeGraphV2.vue?vue&type=style&index=0&id=f64380e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrSchemeGraphV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f64380e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f64380e6', __exports__)) {
    api.reload('f64380e6', __exports__)
  }
  
  module.hot.accept("./AttrSchemeGraphV2.vue?vue&type=template&id=f64380e6", () => {
    api.rerender('f64380e6', render)
  })

}


export default __exports__